module.exports = __webpack_public_path__ + "img/13备份.7a566b0b.jpg";